import Text from '@cartwhl/ui/base/Text';

import { StepData } from '../types';
import Step from './Step';

export default function Steps({
  step,
  steps,
}: {
  step: number;
  steps: StepData[];
}) {
  return (
    <>
      <div className="hidden flex-none gap-2 md:flex">
        <Step status={step === 0 ? 'current' : 'done'}>
          <strong>Step 1:</strong> {steps[0].shortTitle}
        </Step>
        <Step status={step === 1 ? 'current' : step > 1 ? 'done' : 'open'}>
          <strong>Step 2:</strong> {steps[1].shortTitle}
        </Step>
        <Step status={step === 2 ? 'current' : step > 2 ? 'done' : 'open'}>
          <strong>Step 3:</strong> {steps[2].shortTitle}
        </Step>
      </div>
      <div className="flex-none md:hidden">
        <Text as="p" variant="studio/body/sm" className="text-gray-60 mb-1">
          Step {step + 1} of 3
        </Text>
        <Text as="p" variant="studio/body/medium/sm">
          {steps[step].shortTitle}
        </Text>
      </div>
    </>
  );
}
